// extracted by mini-css-extract-plugin
export default {"tabHeaderItem":"TabItem_tabHeaderItem__YfO4Z","active":"TabItem_active__+MedP"};